export function isOneOf<T, TArray extends T>(
	value: T,
	options: ReadonlyArray<TArray>
): value is TArray {
	return options.some((option) => option === value);
}
